




































































import { Component, Vue, Prop } from 'nuxt-property-decorator';

import { PerformanceEvent, usePerformanceUpcomingEvents } from '@/composables/performance-events';
import { formatSv } from '@/composables/datefns';
import { capitalizeFirst } from '@/composables/utils';

import { IconArrowRight } from '@/icons';
import { InjectPageContent } from '@/modules/cms';
import type { ScenkonstOtPerformanceContentDataFragment } from '@/graphql/generated';

@Component({
  components: {
    IconArrowRight,
  },
  setup (props: any) {
    return usePerformanceUpcomingEvents(props.performanceId, 6);
  },
})
export default class BlockShowUpcomingDates extends Vue {
  performanceUpcomingEvents!: PerformanceEvent[];
  performanceUpcomingEventsLoading!: boolean;

  @Prop({ type: String, required: true })
  performanceId!: string;

  @InjectPageContent()
  pageContent!: ScenkonstOtPerformanceContentDataFragment;

  // TODO: add bg type
  @Prop(String)
  backgroundColor!: string

  @Prop(String)
  title!: string

  modalOpen = false;

  get shows () {
    return this.performanceUpcomingEvents.map((event) => {
      const startDate = new Date(event.startDate);
      const endDate = new Date(event.endDate);

      return {
        title: capitalizeFirst(formatSv(startDate, 'EEEE d MMMM')),
        subtitle: `Kl. ${formatSv(startDate, 'HH:mm')} - ${formatSv(endDate, 'HH:mm')} på ${event.locationStage}`,
        cancelled: false,
        soldOut: false,
        bookingLink: event.purchaseUrl,
      };
    });
  }

  openModal (e: boolean) {
    this.modalOpen = e;
  }
}
